/*
 * Copyright (c) Nexign, JSC, 1992-2024.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.29.0
 * @since 1.29.0
 */

import type { FC } from 'react';

import Highlighter from 'react-highlight-words';

import { Checkbox, EllipseText } from '@components/common';
import {
    ChangeSubscribersItemStyled,
    ChangeSubscribersNameStyled,
} from '@pages/WizardAdditionalReports/components/styled/ChangeSubscribersModalStyled';
import { IEditableId } from '@pages/WizardAdditionalReports/types/wizardAdditionalReportsActionTypes';

interface IWizardAdditionalReportsChangeSubscribersListItemProps {
    subscriber: IEditableId;
    switchSubscriber?: (subscriber: IEditableId) => void;
    searchValue: string;
}

export const WizardAdditionalReportsChangeSubscribersListItem:
    FC<IWizardAdditionalReportsChangeSubscribersListItemProps> = (
    {
        subscriber,
        switchSubscriber,
        searchValue,
    },
) => {
    const { id, label, checked } = subscriber;
    const handleOnCheck = (value: boolean) => {
        if (switchSubscriber) {
            switchSubscriber({ ...subscriber, checked: value });
        }
    };

    return (
        <ChangeSubscribersItemStyled className='change-subscribers__item' data-subscriber-id={id} key={id}>
            {switchSubscriber && <Checkbox
                checked={checked}
                className='change-subscribers__item-checkbox'
                onChange={handleOnCheck}
            />}
            <ChangeSubscribersNameStyled className='change-subscribers__item-name'>
                <EllipseText title={label}>
                    <Highlighter
                        autoEscape={true}
                        highlightClassName='change-subscribers__item-text_bold'
                        searchWords={[searchValue]}
                        textToHighlight={label} />
                </EllipseText>
            </ChangeSubscribersNameStyled>
        </ChangeSubscribersItemStyled>
    );
};
